export enum VaccinationStatusEnum {
    PENDING = 0,
    ASSIGNED = 1,
    REPROGRAMMED = 2,
    FINISHED_SUCCESS = 3,
    FINISHED_FAILURE = 4,
}
